import { render, staticRenderFns } from "./AllSoulsDay.vue?vue&type=template&id=d23a5604&scoped=true"
import script from "./AllSoulsDay.vue?vue&type=script&lang=js"
export * from "./AllSoulsDay.vue?vue&type=script&lang=js"
import style0 from "./AllSoulsDay.vue?vue&type=style&index=0&id=d23a5604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a5604",
  null
  
)

export default component.exports